export default "__VITE_ASSET__BntQqrHl__"